import { Email } from "@/entities/Email";
import { Domain } from "@/entities/Domain";

export class EmailManager implements IEmailManager {
  public constructor(private gateway: EmailManagerGateway) {}

  public insertEmail(email: string): Promise<void> {
    return this.gateway.insertEmail(email).then();
  }

  public removeEmail(email: string): Promise<void> {
    return this.gateway.removeEmail(email).then();
  }

  public getDomainChallenge(
    domain: string,
    action: DomainAction
  ): Promise<string> {
    return this.gateway
      .getDomainChallenge(domain, action)
      .then(d => d.challenge);
  }

  public sendPostmasterChallenge(
    domain: string,
    action: DomainAction
  ): Promise<void> {
    return this.gateway.sendPostmasterChallenge(domain, action);
  }

  public sendHostmasterChallenge(
    domain: string,
    action: DomainAction
  ): Promise<void> {
    return this.gateway.sendHostmasterChallenge(domain, action);
  }

  public insertDomain(domain: string): Promise<void> {
    return this.gateway.insertDomain(domain).then();
  }

  public removeDomain(domain: string): Promise<void> {
    return this.gateway.removeDomain(domain).then();
  }

  public verifySubject(subject: string, token: string): Promise<string> {
    return this.gateway.verifySubject(subject, token);
  }

  public checkEmails(emails: string[]): Promise<string[]> {
    return this.gateway
      .checkEmails(emails)
      .then(emailsInList => emailsInList.map(email => email.plain));
  }
}

export interface IEmailManager {
  insertEmail(email: string): Promise<void>;
  removeEmail(email: string): Promise<void>;

  getDomainChallenge(domain: string, action: DomainAction): Promise<string>;
  sendPostmasterChallenge(domain: string, action: DomainAction): Promise<void>;
  sendHostmasterChallenge(domain: string, action: DomainAction): Promise<void>;
  insertDomain(domain: string): Promise<void>;
  removeDomain(domain: string): Promise<void>;

  verifySubject(subject: string, token: string): Promise<string>;
  checkEmails(emails: string[]): Promise<string[]>;
}

export interface EmailManagerGateway {
  insertEmail(email: string): Promise<Email>;
  removeEmail(email: string): Promise<Email>;

  getDomainChallenge(domain: string, action: DomainAction): Promise<Domain>;
  sendPostmasterChallenge(domain: string, action: DomainAction): Promise<void>;
  sendHostmasterChallenge(domain: string, action: DomainAction): Promise<void>;
  insertDomain(domain: string): Promise<Domain>;
  removeDomain(domain: string): Promise<Domain>;

  verifySubject(subject: string, token: string): Promise<string>;
  checkEmails(emails: string[]): Promise<Email[]>;
}

export type DomainAction = "add" | "remove";
